import gsap from 'gsap'
import { forEach } from 'lodash'

import {
  batchRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  SharedAnimation
} from './shared'
import { Animation } from '@/types'

export const menuRevealAnimation = ({
  node,
  mobile,
  context,
  reverse
}: Animation) => {
  if (mobile) return

  const selector = context?.selector || gsap.utils.selector(node)

  const title = selector('[data-motion-title]')[0]
  const names = selector('[data-motion-name]')
  const descriptions = selector('[data-motion-description]')
  const caption = selector('[data-motion-caption]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse)
  })

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, '<')
  }

  let captionAnimation: SharedAnimation
  if (caption) {
    captionAnimation = linesRevealAnimation(caption, reverse)
    timeline.add(captionAnimation.timeline, '<+0.24')
  }

  let namesBatchAnimation: ScrollTrigger[]
  if (names.length > 0) {
    namesBatchAnimation = batchRevealAnimation({
      targets: names,
      reverse,
      stagger: {
        amount: 0.12
      }
    })
  }

  let descriptionsBatchAnimation: ScrollTrigger[]
  if (descriptions.length > 0) {
    descriptionsBatchAnimation = batchRevealAnimation({
      targets: descriptions,
      reverse,
      stagger: {
        amount: 0.24
      }
    })
  }

  return () => {
    timeline.kill()

    titleAnimation?.revert()
    captionAnimation?.revert()

    forEach(namesBatchAnimation || [], (animation) => animation.kill())
    forEach(descriptionsBatchAnimation || [], (animation) => animation.kill())
  }
}
